import { createApp } from "vue";
import slideHomepage from "./SliderProductHomepage.vue";

const app = createApp({
  components: {
    "slide-product-homepage": slideHomepage,
  },
}).mount("#container-slide-homepage");
